import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { availableIcons } from '../../utils';

import { WidgetContainer, WidgetDescription, WidgetDot, WidgetIcon } from './styles';

const mapStateToProps = state => ({
  cityName: state.userPreferences.city.value,
  coordinates: state.userPreferences.city.coordinates,
});

@connect(mapStateToProps)
class WeatherWidget extends Component {
  static propTypes = {
    coordinates: PropTypes.instanceOf(Object),
    cityName: PropTypes.string,
    showCity: PropTypes.bool,
  };

  state = {
    currentWeather: null,
  };

  componentDidMount() {
    const { coordinates, cityName } = this.props;

    if (coordinates || cityName) this.fetchWeatherData();
  }

  componentDidUpdate(prevProps) {
    const { coordinates } = this.props;
    if (prevProps.coordinates !== coordinates) this.fetchWeatherData();
  }

  fetchWeatherData = async () => {
    const { coordinates, cityName } = this.props;
    let url;

    if (coordinates) {
      url = `https://api.openweathermap.org/data/2.5/weather?lat=${coordinates.latitude}&lon=${coordinates.longitude}&units=imperial&appid=${process.env.OPENWEATHER_APIKEY}`;
    } else {
      url = `https://api.openweathermap.org/data/2.5/weather?q=${cityName},us&units=imperial&appid=${process.env.OPENWEATHER_APIKEY}`;
    }


    try {
      const res = await fetch(url);
      const json = await res.json();
      await this.setState({
        currentWeather: {
          temperature: json.main.temp,
          weather: json.weather[0].main,
        },
      })
    } catch (err) {
      this.setState({
        currentWeather: null
      });
    }
  };

  render() {
    const { currentWeather } = this.state;
    const { cityName, showCity } = this.props;
    return (
      <WidgetContainer>
        <WidgetIcon>{currentWeather ? availableIcons[currentWeather.weather.toLowerCase()] : ''}</WidgetIcon>
        <WidgetDescription>{currentWeather ? `${Math.round(currentWeather.temperature)} °F` : '-'}</WidgetDescription>
        <WidgetDot>&#8226;</WidgetDot>
        <WidgetDescription>{currentWeather ? currentWeather.weather : '-'}</WidgetDescription>
        {showCity && (
          <Fragment>
            <WidgetDot>&#8226;</WidgetDot>
            <WidgetDescription>{cityName}</WidgetDescription>
          </Fragment>
        )}
      </WidgetContainer>
    );
  }
}

export default WeatherWidget;
